/* eslint-disable react/no-multi-comp,camelcase */
import React, { Component } from 'react';
import moment from 'moment';
import Switch from 'react-ios-switch';
import { connect } from 'react-redux';
import InfoTooltip from '../../../common/tooltip/info/index';
import { MANAGER } from '../../../../constants/roles';
import GeneralTableSubRow from '../sub-row';
import getCurrencySymbol from '../../../../constants/currencies';
import AllActionViews from '../../../actions/view';
import rowContainer from '../../../../containers/admin/table/row';
import { withNamespaces } from 'react-i18next';


class GeneralTableRow extends Component {
  constructor(props) {
    super(props);

    this.checkSelected = this.checkSelected.bind(this);
    this.switchOnChange = this.switchOnChange.bind(this);
    this.subRequestShowOrHide = this.subRequestShowOrHide.bind(this);
    this.state = {
      subRequestShow: false,
      icon: 'up'
    };
  }

  // eslint-disable-next-line react/sort-comp
  checkSelected() {
    const { selectedRequests, group_id } = this.props;

    if (selectedRequests.length > 0) {
      const request = selectedRequests.find(req => req.group_id === group_id);

      return request.selected;
    }

    return false;
  }

  switchOnChange(selected) {
    this.setState({ selected });

    const { group_id, selectRequest, pageCount } = this.props;

    selectRequest(selected, group_id, pageCount);
  }


  subRequestShowOrHide() {
    const { subRequestShow } = this.state;

    this.setState({
      subRequestShow: (!subRequestShow),
      icon: (subRequestShow ? 'up' : 'down'),
    });
  }


  render() {
    const {
      request, subRequest, actionButtonEvents, group_id, selectRequest, t
    } = this.props;
    const { calculatedAmount } = request;

    return (
      <div className="requests-row">
        <div
          className="first-request pointer"
          onClick={this.subRequestShowOrHide}
        >
          <div className="row">
            <div className="col-md-first">
              {
                    this.props.subRequest.length > 1 || (request && request.revisions && request.revisions.length > 0)
                      ? (
                        <span className="detail-icons">
                          {
                              this.props.subRequest.length > 1
                                ? <i className={`fa fa-angle-${this.state.icon}`} />
                                : null
                          }
                          {
                                    request && request.revisions && request.revisions.length > 0
                                      ? (
                                        <InfoTooltip info={t('revised')}>
                                          <i className="fa fa-star star-color" aria-hidden="true" />
                                        </InfoTooltip>
                                      )
                                      : null
                                }
                        </span>
                      )
                      : null
                }
            </div>
            <div className="col-md-1">
              <Switch
                className="switch"
                checked={this.checkSelected()}
                onChange={(checked) => { this.switchOnChange(checked); }}
              />
            </div>
            <div className="col-md-2">
              <span className="employeeName">
                {request.employee.employeeName}
              </span>
            </div>
            <div className="col-md-2">
              <span className="travelStartDateAndHour">
                {moment(new Date(request.travelStartDate)).format('DD-MM-YYYY')}
                {' '}
                {request.travelStartHour}
              </span>
              <br />
              <span className="travelEndDateAndHour">
                {moment(new Date(request.travelEndDate)).format('DD-MM-YYYY')}
                {' '}
                {request.travelEndHour}
              </span>
            </div>
            <div className="col-md-2 ellipsis">
              <span className="travelReasons">
                {request.travelReasons.map(reason => (
                  <span key={reason.value} className="reasonsValue">
                    {reason.label}
                  </span>
                ))}
              </span>
            </div>
            <div className="col-md-1 ellipsis">
              {
                                request.type === 'domestic'
                                  ? (request.domestic.provinces.map(p => (
                                    <span key={p.value} className="domesticValue">
                                      {' '}
                                      {p.label}
                                      {' '}
                                    </span>
                                  )))
                                  : (
                                    <span className="abroadCountry">
                                      {request.abroad.country}
                                    </span>
                                  )
                            }
            </div>
            <div className="col-md-1">
              <InfoTooltip info={t('travelExpenseGrossPayment')}>
                <span className="calculatedAmount">
                  {calculatedAmount.amount}
                  {' '}
                  {getCurrencySymbol(calculatedAmount.abroadCurrency)}
                  {' '}
                </span>
              </InfoTooltip>
            </div>
            <div className="col-md-1">
              <InfoTooltip info={t('individualAccommodationAmount')}>
                <span className="individualAccommodationAmount">
                  { calculatedAmount.individualAccommodationAmount
                    ? calculatedAmount.individualAccommodationAmount
                    : 0}
                  {' '}
                  {getCurrencySymbol(calculatedAmount.abroadCurrency)}
                </span>
              </InfoTooltip>
            </div>
            <div className="col-md-last">
              <AllActionViews
                roles={[MANAGER]}
                actionButtonEvents={actionButtonEvents}
                request={request}
              />
            </div>
          </div>
        </div>
        <div
          className="sub-requests"
          style={{ display: (this.state.subRequestShow ? 'block' : 'none') }}
        >
          {
                        subRequest.length > 1
                        // eslint-disable-next-line array-callback-return,consistent-return
                          ? subRequest.map((req, index) => {
                            if (index !== 0) {
                              return (
                                <GeneralTableSubRow
                                  actionButtonEvents={actionButtonEvents}
                                  key={req._id}
                                  group_id={group_id}
                                  select={selectRequest}
                                  request={req}
                                />
                              );
                            }
                          })
                          : null
                    }
        </div>
      </div>
    );
  }
}


export default withNamespaces()(connect(...rowContainer)(GeneralTableRow));



// WEBPACK FOOTER //
// ./src/components/admin/table/row/index.js